import Vue from 'vue';
import { mapGetters } from 'vuex';

export default Vue.component('column', {
  template: require('./template.html'),
  name: 'column',
  computed: {
    ...mapGetters([
      'currentPage',
      'globalDragEl',
      'dragging',
    ]),
    watchDroplets() {
      const drps = this.column.droplets;
      let cls = '';
      if (drps.length < 1) {
        cls = 'drzDroplet-puddleDropped';
      }
      return cls;
    },
    roamingTemplate() {
      return this.currentPage.type !== 'template' && this.droplet.templateRegion;
    },
    draggingTemplateDrp() {
      return this.globalDragEl === 'templateDroplet';
    },
  },
  watch: {
    'column.droplets': function watchDroplets() {
      if (this.droplet.equalHeights) {
        // if equal heights is enabled, We need to give the jquery plugin
        // a split second (after vue splices / renders new droplets in the DOM)
        // to recalc the heights.
        setTimeout(() => {
          this.$vnode.context.bindPlugin();
        }, 250);
      }
      // bouncing the component key will force a re-render. This is needed
      // for dragula to re insert the draggable container. See @/directives/main.js
      this.renderKey = Date.now();
    },
  },
  props: [
    'column',
    'droplet',
    'display',
  ],
  data() {
    const renderKey = Date.now();
    return {
      renderKey,
    };
  },
  created() {
    this.checkNewValues();
  },
  methods: {
    checkNewValues() {
      const values = [];
      if (!this.column.bgImg) {
        values.push({ key: 'bgImg', value: null });
      }
      if (values.length > 0) {
        this.$store.dispatch('setNewDropletValues', {
          drp: this.column,
          vm: this,
          values,
        });
        this.$emit('css-generator');
      }
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/columns/components/column/index.js